// EmpatheticCaregiversSection.js
import React from "react";
import empatheticCaregiversImage from "../assets/empathetic-caregivers-image.jpg";

const EmpatheticCaregiversSection = () => {
  return (
    <section className="relative bg-white overflow-hidden">
      {/* Top curved section with gradient */}
      <div
        className="relative"
        style={{
          background: "linear-gradient(90deg, #AD2647 0%, #E85D2C 100%)",
          clipPath: "ellipse(150% 100% at 50% 0%)",
          paddingBottom: "120px",
        }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-16 pb-8">
          <div className="max-w-3xl">
            <p className="text-white text-sm font-light tracking-wider mb-3 uppercase">
              ALLAWAH HOME CARE
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
              Proudly Caring for Coolamon's Seniors — One Home at a Time
            </h2>
            <p className="text-white text-sm md:text-base font-light leading-relaxed">
              At Allawah Compassionate Home Care, we believe every senior
              deserves to feel valued, respected, and supported in the place
              they call home. Our caregivers provide personalised care that
              promotes safety, independence, and companionship—helping families
              across Coolamon and beyond find peace of mind and loved ones live
              life to the fullest.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom section with image and content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={empatheticCaregiversImage}
              alt="Caregiver with elderly woman"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Our Caregivers are Empathetic and Caring
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                At Allawah Lodge, we know that hospice care is about more than
                physical support — it's about compassion, understanding, and
                presence. Our caregivers are trained to bring peace of mind to
                families, easing daily worries so you can focus on what truly
                matters: spending meaningful time with your loved one. We
                provide steady guidance and emotional reassurance during life's
                most sensitive moments, ensuring every client feels valued,
                cared for, and at ease.
              </p>

              <p className="font-normal">
                Our hospice caregivers can assist with:
              </p>
            </div>

            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Bathing, showering, and bed baths</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Laundry and light housekeeping</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Toilet and incontinence care</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Grooming and oral hygiene</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmpatheticCaregiversSection;
